import React, { Component } from 'react';
import { Button } from 'react-bootstrap';

/** UI Kit */
import { TxtTitle1 } from '@atresmedia/intranet-texts';

/** Core */
import { isNaN } from 'lodash';
import BoxInside from '../../../core/BoxInside';
import Modal from '../../../core/Modal';

/** Views */
import FormControl from './FormControl';
import SearchFormControl from './SearchFormControl';
import SearchTableControl from './SearchTableControl';

/** Utils */
import { dateToString } from '../../../../utils/formatDate';

/** Styles */
import {
  StyledAccessControl,
  StyledTitleWidget,
  StyledSaveWarning
} from './style';

import {
  postImputationTime,
  putImputationTime,
  getImputedDaysOnScroll,
  getImputedDaysByDate,
  getExcelImputedDaysOnScroll,
  getManagedUsers
} from '../../../../utils/apiControlAccess';

import { getUserDetails } from '../../../../utils/apiUser';

import { ControlAccesoWhite } from '../../../../../assets/images/index';

class AccessControl extends Component {
  constructor() {
    super();
    this.state = {
      currentImputation: {},
      currentPage: 0,
      imputedDays: {
        total: null,
        content: []
      },
      loadingData: false,
      page: 0,
      dateTo: null,
      dateFrom: null,
      userId: null,
      username: null,
      user: {
        name: null,
        lastname: null
      },
      isLoading: true,
      error: {
        show: false,
        text: ''
      },
      listUsers: [],
      postResult: {
        success: false,
        show: false,
        text: ''
      }
    };
  }

  componentDidMount() {
    getManagedUsers().then(data =>
      this.setState({
        listUsers: data.map(item => ({
          text: item.nombreEmpleado ? `${item.nombreEmpleado} ` : 'x',
          value: item.idEmpleado
        }))
      })
    );

    // El fichaje de hoy se busca igual que el de cualquier otro dia, y para
    // eso hace falta el username: se carga despues del perfil
    getUserDetails()
      .then(
        data =>
          new Promise(resolve =>
            this.setState(
              {
                user: {
                  userId: data.userProfile.userId,
                  name: data.userProfile.name,
                  lastname: data.userProfile.lastname,
                  avatarPhoto: data.userProfile.avatarPhoto
                },
                // Fuera de `user` para no enviarlo en el cuerpo del POST/PUT
                username: data.userProfile.username
              },
              resolve
            )
          )
      )
      .then(() => this.findImputationByDate(dateToString(new Date())))
      .then(today => {
        this.setState({
          currentImputation: today || {},
          isLoading: false
        });
      })
      .catch(() => {
        this.setState({
          isLoading: false
        });
      });
  }

  // Busca la imputacion del usuario para el dia indicado (YYYY-MM-DD); null si no hay
  findImputationByDate = date => {
    const { username } = this.state;
    // toDate es exclusivo, igual que en handleSearch
    const nextDay = dateToString(
      new Date(new Date(`${date}T00:00:00`).getTime() + 86400000)
    );
    return getImputedDaysByDate(username, date, nextDay).then(result => {
      const list = Array.isArray(result)
        ? result
        : (result && result.content) || [];
      return (
        list.find(item => String(item.date).substring(0, 10) === date) || null
      );
    });
  };

  // `existing` es el fichaje del dia que el formulario ya cargo (null si no hay).
  // Devuelve el registro guardado, o null si falla, para que el formulario
  // sepa si a partir de ahora esta modificando
  sendInput = (data, existing) => {
    const { user } = this.state;
    const dataWithUser = { ...data, ...user };

    // Si el dia ya tiene imputacion se actualiza esa; si no, se crea una nueva
    const payload = existing ? { ...existing, ...dataWithUser } : dataWithUser;
    const request = existing
      ? putImputationTime(payload)
      : postImputationTime(payload);

    return request
      .then(result => {
        if (existing) {
          return payload;
        }
        // El siguiente guardado necesita el id del registro creado; si el POST
        // no lo devuelve se busca
        return result && result.id
          ? result
          : this.findImputationByDate(data.date);
      })
      .then(saved => {
        this.setState({
          postResult: {
            success: true,
            show: true,
            text: 'Su imputación se guardó correctamente.'
          }
        });
        return saved || payload;
      })
      .catch(e => {
        this.setState({
          error: {
            show: true,
            text: e.message ? e.message : `Error ${e.code}`
          },
          postResult: {
            success: false,
            show: true,
            text: 'Error: No se pudo guardar su imputación.'
          }
        });
        return null;
      });
  };

  handleSearch = (userSelected, dateFrom, dateTo) => {
    const checkDateFrom = new Date(dateFrom);
    const checkDateTo = new Date(dateTo);
    const dateFromString = !isNaN(checkDateFrom.getHours())
      ? dateToString(new Date(dateFrom))
      : dateToString(new Date(1900, 0, 1));
    const dateToPlusOne =
      dateTo !== null && !isNaN(checkDateTo.getHours())
        ? new Date(new Date(dateTo).getTime() + 86400000)
        : new Date(new Date().getTime() + 86400000);
    const dateToPlusOneString = dateToString(dateToPlusOne);
    this.setState(
      {
        dateTo: dateToPlusOneString,
        dateFrom: dateFromString,
        userId: userSelected,
        currentPage: 0
      },
      () => {
        getImputedDaysOnScroll(
          userSelected,
          dateFromString,
          dateToPlusOneString,
          this.state.currentPage,
          10
        )
          .then(input => {
            this.setState({ imputedDays: input, page: 1 });
          })
          .catch(e => {
            this.setState({
              error: {
                show: true,
                text: e.message ? e.message : `Error ${e.code}`
              }
            });
          });
      }
    );
  };

  goToPreviousPage = () => {
    const { currentPage, userId, dateFrom, dateTo } = this.state;
    if (currentPage > 0) {
      const previousPage = currentPage - 1;
      this.setState({ currentPage: previousPage });
      getImputedDaysOnScroll(userId, dateFrom, dateTo, previousPage, 10)
        .then(input => {
          this.setState({ imputedDays: input });
        })
        .catch(e => {
          this.setState({
            error: {
              show: true,
              text: e.message
                ? e.message
                : `No se ha realizado ninguna busqueda: Error ${e.code}`
            }
          });
        });
    }
  };

  goToNextPage = () => {
    const { currentPage, userId, dateFrom, dateTo } = this.state;
    const nextPage = currentPage + 1;
    this.setState({ currentPage: nextPage });
    getImputedDaysOnScroll(userId, dateFrom, dateTo, nextPage, 10)
      .then(input => {
        this.setState({ imputedDays: input });
      })
      .catch(e => {
        this.setState({
          error: {
            show: true,
            text: e.message
              ? e.message
              : `No se ha realizado ninguna busqueda: Error ${e.code}`
          }
        });
      });
  };

  handleSearchExcel = (userSelected, dateFrom, dateTo) => {
    const checkDateFrom = new Date(dateFrom);
    const checkDateTo = new Date(dateTo);
    const dateFromString = !isNaN(checkDateFrom.getHours())
      ? dateToString(new Date(dateFrom))
      : dateToString(new Date(1900, 0, 1));

    const dateToPlusOne =
      dateTo !== null && !isNaN(checkDateTo.getHours())
        ? new Date(new Date(`'${dateTo}'`).getTime() + 86400000)
        : new Date(new Date().getTime() + 86400000);

    const dateToPlusOneString = dateToString(dateToPlusOne);
    this.setState({
      dateTo: dateToPlusOneString,
      dateFrom: dateFromString,
      userId: userSelected
    });

    getExcelImputedDaysOnScroll(
      userSelected,
      dateFromString,
      dateToPlusOneString
    )
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'empleados.xlsx');
        document.body.appendChild(link);
        link.click();
      })
      .catch(error => {
        console.error('Error al descargar el archivo:', error);
      });
  };

  handleScroll = async () => {
    const { userId, dateFrom, dateTo, imputedDays, page } = this.state;
    if (
      imputedDays.content.length !== 0 &&
      imputedDays.content.length < imputedDays.total
    ) {
      this.setState({ loadingData: true });
      await getImputedDaysOnScroll(userId, dateFrom, dateTo, page, 10)
        .then(input => {
          this.setState({ loadingData: false, page: page + 1 });
          const newArray = imputedDays.content.concat(input.content);
          this.setState(prevState => ({
            imputedDays: {
              ...prevState.imputedDays,
              content: newArray
            }
          }));
        })
        .catch(e => {
          this.setState({
            error: {
              show: true,
              text: e.message ? e.message : `Error ${e.code}`
            },
            loadingData: false
          });
        });
    }
  };

  closeModalError = () =>
    this.setState({
      error: {
        show: false
      }
    });

  render() {
    const { className } = this.props;
    const {
      currentImputation,
      isLoading,
      imputedDays,
      user,
      error,
      postResult,
      listUsers,
      loadingData,
      currentPage
    } = this.state;
    return (
      <React.Fragment>
        <StyledAccessControl className={className}>
          <BoxInside>
            <StyledTitleWidget
              title="Control de acceso"
              type="audiences"
              icon={ControlAccesoWhite}
              small
            />
            <p className="text mb-30">Rellena las horas de entrada y salida</p>
            <StyledSaveWarning role="alert">
              <span className="save-warning-icon" aria-hidden="true">
                ⚠️
              </span>
              <div>
                <strong className="save-warning-title">
                  Importante: los datos no se guardan automáticamente
                </strong>
                Después de rellenar o modificar las horas, pulsa el botón{' '}
                <strong>«Guardar jornada»</strong> para guardar los cambios. Si
                no lo pulsas, los datos se perderán.
              </div>
            </StyledSaveWarning>
            {!isLoading && (
              <FormControl
                onSubmit={this.sendInput}
                onLoadDay={this.findImputationByDate}
                postResult={postResult}
                currentDayImputation={currentImputation}
              />
            )}
            <TxtTitle1 className="mt-30 mb-10">Buscar registros</TxtTitle1>
            <SearchFormControl
              onSubmit={this.handleSearch}
              onSubmitExcel={this.handleSearchExcel}
              listUsers={listUsers}
            />

            <SearchTableControl
              user={user}
              dataSearchAccess={imputedDays.content}
              currentPage={currentPage}
              goToPreviousPage={this.goToPreviousPage}
              goToNextPage={this.goToNextPage}
            />
            <div style={{ display: 'flex' }}>
              <Button
                onClick={this.goToPreviousPage}
                disabled={currentPage === 0}
              >
                Anterior
              </Button>
              <Button
                onClick={this.goToNextPage}
                disabled={imputedDays.content.length === 0}
              >
                Siguiente
              </Button>
              <div style={{ marginLeft: 'auto' }}>Página {currentPage + 1}</div>
            </div>
          </BoxInside>
        </StyledAccessControl>
        {error && error.show && (
          <Modal
            clickCloseIcon={this.closeModalError}
            title="Se ha producido un error"
          >
            {error.text}
          </Modal>
        )}
        {loadingData && (
          <Modal title="Cargando">Cargando datos. Por favor, espere.</Modal>
        )}
      </React.Fragment>
    );
  }
}

export default AccessControl;
